import React from 'react';
import {Link} from '../Link';
import {gtmDataPush, TRACK_EVENT} from '../../utils/analytics';
import {SlimIcon, SlimIconProps} from './SlimIcon';
import {IconName} from './SvgIcon';

export const socialMediaPlatforms = [
  {
    name: 'Linkedin',
    url: 'https://www.linkedin.com/company/ready2order-gmbh'
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/ready2order'
  },
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/ready2order'
  },
  {
    name: 'Youtube',
    url: 'https://www.youtube.com/channel/UC5cw4pnsypD2mGIwAY2FqcA'
  }
];

type SocialMediaIconsProps = {
  iconColor: SlimIconProps['color'];
};

type SocialMediaLinkProps = {
  platform: {name: string; url: string};
  iconColor: SocialMediaIconsProps['iconColor'];
};

const SocialMediaLink: React.FC<SocialMediaLinkProps> = ({platform, iconColor}: SocialMediaLinkProps) => {
  const handleSocialIconClick = React.useCallback(() => {
    gtmDataPush({
      event: TRACK_EVENT.SOCIAL_ICONS,
      data: {
        social_network: platform.name
      }
    });
  }, []);

  return (
    <Link className='mr-4' target='_blank' to={platform.url} rel='noopener noreferrer' aria-label={platform.name} onClick={handleSocialIconClick}>
      <SlimIcon name={platform.name.toLowerCase() as IconName} color={iconColor} size='tiny' />
    </Link>
  );
};

export const SocialMediaIcons: React.FC<SocialMediaIconsProps> = ({iconColor}) => (
  <>
    {socialMediaPlatforms.map(platform => (
      <SocialMediaLink key={platform.name} platform={platform} iconColor={iconColor} />
    ))}
  </>
);
